import { Component } from "@angular/core";
import { UserService } from "@main-services/user.service";
import { ModalService } from "@core-services/modal.service";
import { Router } from "@angular/router";
import { VERIFICATION_MODAL_ROUTE } from "@helpers/constants";
import { VerificationModalFacade } from "@modules/verification/modal/state/verification-modal.facade";

@Component({
	selector: "verification-start",
	templateUrl: "./verification-start.component.html",
	standalone: false
})
export class VerificationStartComponent {
	public constructor(
		private verificationModalFacade: VerificationModalFacade,
		private modalService: ModalService,
		private userService: UserService,
		private router: Router
	) {}

	public verify(): void {
		if (!this.verificationModalFacade.openVerification()) {
			this.router.navigate(VERIFICATION_MODAL_ROUTE, {
				skipLocationChange: true
			});
		}
	}

	public isVerificationPending(): boolean {
		return this.userService.isVerificationPending();
	}
}
